
function getFunctions(files) {

    let functions = [];

    files.forEach(file => {
        const classRegex = /class\s+(\w+)/g
        let className = null;
        let classMatch = classRegex.exec(file);
        if (classMatch) {
            className = classMatch[1];
        }
        const functionRegex = /(static)?\s*(\w+)\(([\w\s,]*)\)\s*{/g;
        let match = null;
        do {
            match = functionRegex.exec(file);
            if (match) {
                const parameterString = match[3];
                let parameters = [];
                if (parameterString.length !== 0) {
                    parameters = parameterString.split(',').map(parameter => parameter.replace(" ", ""));
                }
                let isStatic = match[1] != null;
                let name = match[2];
                let displayName = name;
                if (className != null) {
                    displayName = className + "." + name;
                }
                functions.push({
                    name,
                    className,
                    parameters,
                    isStatic,
                    displayName
                });
            }
        } while (match);
    });

    return functions;
}

export default {getFunctions}


// WEBPACK FOOTER //
// ./src/parser/JavascriptParser.js